var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRow55(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_49563)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1322_49563)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5037 38.5743C45.4762 39.61 34.9731 43.8426 32.7371 44.9852C30.501 46.1279 29.2588 46.1168 27.4924 45.2892C25.726 44.4615 14.5489 40.0365 12.5354 39.0932C11.5292 38.622 11 38.224 11 37.8481V34.0844C11 34.0844 25.5513 30.9796 27.9005 30.1536C30.2495 29.3276 31.0645 29.2977 33.0636 30.0154C35.0629 30.7334 47.0165 32.8471 48.9923 33.5564L48.9914 37.2669C48.9917 37.639 48.5358 38.0471 47.5037 38.5743Z",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.503 34.8317C45.4756 35.8671 34.9728 40.0998 32.7367 41.2422C30.5008 42.385 29.2587 42.3738 27.4923 41.5462C25.7258 40.7191 14.5491 36.2934 12.5358 35.3507C10.5225 34.4074 10.4804 33.7583 12.4581 32.9993C14.4357 32.24 25.5512 27.9658 27.9006 27.1398C30.2496 26.314 31.0645 26.2839 33.0635 27.0019C35.0627 27.7196 45.5029 31.7924 47.4783 32.5015C49.4545 33.2115 49.5304 33.7961 47.503 34.8317Z",
    fill: "#C6302B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5037 32.4843C45.4762 33.5203 34.9731 37.7527 32.7371 38.8957C30.501 40.0379 29.2588 40.0269 27.4924 39.1992C25.7259 38.372 14.5489 33.9466 12.5354 33.0033C11.5292 32.532 11 32.1347 11 31.7587V27.9944C11 27.9944 25.5513 24.8899 27.9005 24.0638C30.2495 23.2378 31.0645 23.2078 33.0636 23.9256C35.0631 24.6435 47.0167 26.7568 48.9923 27.4661L48.9914 31.1771C48.9917 31.5491 48.5358 31.9572 47.5037 32.4843Z",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.503 28.7418C45.4756 29.7774 34.9728 34.0099 32.7367 35.1527C30.5008 36.2951 29.2587 36.2839 27.4923 35.4563C25.7258 34.6292 14.5491 30.2036 12.5358 29.2608C10.5225 28.3178 10.4804 27.6685 12.4581 26.9092C14.4357 26.1504 25.5513 21.8759 27.9006 21.05C30.2496 20.2241 31.0645 20.1942 33.0635 20.912C35.0627 21.6297 45.5029 25.7022 47.4783 26.4116C49.4545 27.1214 49.5304 27.7062 47.503 28.7418Z",
    fill: "#C6302B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5037 26.1676C45.4762 27.2033 34.9731 31.436 32.7371 32.579C30.501 33.7214 29.2588 33.7102 27.4924 32.8825C25.7259 32.0553 14.5489 27.6297 12.5354 26.6869C11.5292 26.2152 11 25.8177 11 25.4421V21.6777C11 21.6777 25.5513 18.5733 27.9005 17.7474C30.2495 16.9212 31.0645 16.8915 33.0636 17.6092C35.0631 18.327 47.0167 20.4403 48.9923 21.1497L48.9914 24.8606C48.9917 25.2322 48.5358 25.6403 47.5037 26.1676Z",
    fill: "#912626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5029 22.4272C45.4755 23.4628 34.9727 27.6955 32.7367 28.8379C30.5008 29.9803 29.2586 29.9691 27.4922 29.1419C25.7259 28.3143 14.5491 23.889 12.5359 22.946C10.5225 22.0032 10.4805 21.3537 12.458 20.5946C14.4357 19.8356 25.5512 15.5617 27.9005 14.7355C30.2495 13.9095 31.0644 13.8798 33.0635 14.5976C35.0626 15.3155 45.5028 19.388 47.4782 20.0974C49.4544 20.8067 49.5303 21.3915 47.5029 22.4272Z",
    fill: "#C6302B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6395 18.7644L31.3731 19.0968L30.6419 20.8213L29.4608 18.8969L25.6891 18.5647L28.5035 17.57L27.659 16.043L30.294 17.053L32.778 16.2559L32.1066 17.8348L34.6395 18.7644ZM30.4469 27.1307L24.3507 24.6526L33.086 23.3384L30.4469 27.1307ZM21.9951 19.723C24.5736 19.723 26.664 20.5172 26.664 21.4966C26.664 22.4764 24.5736 23.2705 21.9951 23.2705C19.4165 23.2705 17.3262 22.4763 17.3262 21.4966C17.3262 20.5172 19.4165 19.723 21.9951 19.723Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.499 19.2365L43.6689 21.2388L38.5035 23.2392L38.499 19.2365Z",
    fill: "#621B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7793 21.4538L38.4989 19.2363L38.5034 23.2391L37.9425 23.4541L32.7793 21.4538Z",
    fill: "#9A2928"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_49563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1322_49563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 32,
    fill: "white",
    transform: "translate(11 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow55);
export default __webpack_public_path__ + "static/media/row-5-5.6398f32c504a7f41864520ea85b31e5b.svg";
export { ForwardRef as ReactComponent };